import React, { useEffect } from "react";
import { useRedirect } from "../services/hooks/useRedirect";
import { enableTooltip } from "../public/js/core";

const Rating = React.memo(
  ({
    rating,
    link,
    size = "xxs",
    className = "",
    isRatable = false,
    onRatingChange,
    tooltip = false,
    ratingStyle = "dark",
  }) => {
    const { redirect } = useRedirect();

    const style = {
      cursor: isRatable || link ? "pointer" : "auto",
    };

    const handleClick = (e) => {
      e.preventDefault();

      if (!isRatable && link) {
        redirect(link);
      }
    };

    const handleRatingChange = (e) => {
      e.preventDefault();

      if (isRatable) {
        onRatingChange(Number(e.target.dataset.ratingValue));
      }
    };

    useEffect(() => {
      if (tooltip) {
        enableTooltip();
      }
    }, []);

    return (
      <>
        {/* Rating */}
        <div
          className={`rating font-size-${size} ${className} text-${ratingStyle} justify-content-center`}
          data-value={rating ? Math.ceil(Number(rating)) : 0}
          style={style}
          onClick={handleClick}
        >
          {rating && rating < 1 ? (
            <div
              className="rating-item"
              data-toggle={tooltip ? "tooltip" : ""}
              title={tooltip ? "Bad" : ""}
            >
              <i className="fas fa-star-half-alt" />
            </div>
          ) : (
            <div
              className="rating-item"
              data-toggle={tooltip ? "tooltip" : ""}
              title={tooltip ? "Bad" : ""}
            >
              <i
                className="fas fa-star"
                data-rating-value={1}
                onClick={handleRatingChange}
              />
            </div>
          )}

          {rating && rating > 1 && rating < 2 ? (
            <div
              className="rating-item"
              data-toggle={tooltip ? "tooltip" : ""}
              title={tooltip ? "Poor" : ""}
            >
              <i className="fas fa-star-half-alt" />
            </div>
          ) : (
            <div
              className="rating-item"
              data-toggle={tooltip ? "tooltip" : ""}
              title={tooltip ? "Poor" : ""}
            >
              <i
                className="fas fa-star"
                data-rating-value={2}
                onClick={handleRatingChange}
              />
            </div>
          )}

          {rating && rating > 2 && rating < 3 ? (
            <div
              className="rating-item"
              data-toggle={tooltip ? "tooltip" : ""}
              title={tooltip ? "Average" : ""}
            >
              <i className="fas fa-star-half-alt" />
            </div>
          ) : (
            <div
              className="rating-item"
              data-toggle={tooltip ? "tooltip" : ""}
              title={tooltip ? "Average" : ""}
            >
              <i
                className="fas fa-star"
                data-rating-value={3}
                onClick={handleRatingChange}
              />
            </div>
          )}

          {rating && rating > 3 && rating < 4 ? (
            <div
              className="rating-item"
              data-toggle={tooltip ? "tooltip" : ""}
              title={tooltip ? "Great" : ""}
            >
              <i className="fas fa-star-half-alt" />
            </div>
          ) : (
            <div
              className="rating-item"
              data-toggle={tooltip ? "tooltip" : ""}
              title={tooltip ? "Great" : ""}
            >
              <i
                className="fas fa-star"
                data-rating-value={4}
                onClick={handleRatingChange}
              />
            </div>
          )}

          {rating && rating > 4 && rating < 5 ? (
            <div
              className="rating-item"
              data-toggle={tooltip ? "tooltip" : ""}
              title={tooltip ? "Excellent" : ""}
            >
              <i className="fas fa-star-half-alt" />
            </div>
          ) : (
            <div
              className="rating-item"
              data-toggle={tooltip ? "tooltip" : ""}
              title={tooltip ? "Excellent" : ""}
            >
              <i
                className="fas fa-star"
                data-rating-value={5}
                onClick={handleRatingChange}
              />
            </div>
          )}
        </div>
      </>
    );
  }
);

export default Rating;
